export default __webpack_public_path__ + "static/media/m.7910f507.png";